module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0140.jpg?v=7b1dbc7a";